/**
 * The ONE bottom-sheet look on phones, shared by every sheet that rises from the bottom (the Drawer, the
 * MobileSheet on top of it, and a bottom-side Sheet): iOS-style large top corners, no top border line, and a
 * small grabber. Change it here, never per screen.
 */
export const bottomSheetCornerClassName = "rounded-t-[2rem]"

/** The iOS grabber: a short, thin pill near the top edge. */
export const bottomSheetGrabberClassName = "mx-auto mt-2.5 h-[5px] w-9 shrink-0 rounded-full bg-muted-foreground/30"
